import { render, staticRenderFns } from "./SickLeaveCreationModal.vue?vue&type=template&id=140fda14&scoped=true&"
import script from "./SickLeaveCreationModal.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140fda14",
  null
  
)

export default component.exports